import { FC } from 'react';
import { ActionModal, ModalTypes } from '@monorepo/controlled/src/components/modal/modals/action-modal/action-modal';
import { IModalInjectProps } from '@monorepo/controlled/src/components/modal/modal/modal';

interface IRegenerateLinkModal extends IModalInjectProps {
	onConfirm: () => void;
}

export const RegenerateLinkModal: FC<Partial<IRegenerateLinkModal>> = ({ onConfirm, closeModal, id }) => (
	<ActionModal type={ModalTypes.Warning} primaryBtnTitle={'Generate Link'} onAction={onConfirm} closeModal={closeModal} id={id ?? 0}>
		<div>
			<p>This will re-activate your link and re-enroll you in the campaign.</p>
		</div>
	</ActionModal>
);
